import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ParentSidebarRoute {
  label: string;
  path: string;
}

interface SidebarNavigationStore {
  parentRoute: ParentSidebarRoute;
  setParentRoute: (parentRoute: ParentSidebarRoute) => void;
}

export const DEFAULT_PARENT_SIDEBAR_ROUTE: ParentSidebarRoute = {
  label: "companies",
  path: "/companies",
};

export const sidebarNavigationStore = create<SidebarNavigationStore>()(
  persist(
    (set) => ({
      parentRoute: DEFAULT_PARENT_SIDEBAR_ROUTE,
      setParentRoute: (parentRoute) => {
        set({ parentRoute });
      },
    }),
    { name: "sidebar-navigation" },
  ),
);
